'use client';

import { UnauthorizedModal } from '@brahma/components';
const UnauthorizedModalWrapper = (props: any) => {
  return <UnauthorizedModal {...props} data-sentry-element="UnauthorizedModal" data-sentry-component="UnauthorizedModalWrapper" data-sentry-source-file="index.tsx" />;
};
export default UnauthorizedModalWrapper;